// Старший объекта: кто отвечает за него и кому приходят уведомления по нему.
//
// Колонка лежала в базе с первой миграции и наружу не выходила ни разу — назначить старшего
// было нечем ни с одного экрана. Цена этого стала видна 07.09.2026, когда появился сторож
// обходов: уведомление «на объекте не сходили в обход» адресуется именно старшему, и без этого
// поля оно осталось бы написанным и никому не слышным.
//
// Выбор из реестра людей общим средством (`useЛюдиДляВыбора`): второй список тех же людей
// означал бы два запроса за одним ответом и две раскладки одних и тех же фамилий на соседних
// экранах.

import { useState } from 'react';

import type { ApiError } from '@/shared/errors/api-error';
import { useЛюдиДляВыбора } from '@/shared/people/lookup';
import { NO_VALUE, SelectField } from '@/shared/ui/select-field';
import { TextField } from '@/shared/ui/text-field';

export interface ВыборСтаршегоProps {
  id: string;
  значение: string | null;
  наВыбор: (значение: string | null) => void;
}

export function ВыборСтаршего({ id, значение, наВыбор }: ВыборСтаршегоProps) {
  const [поиск, setПоиск] = useState('');
  const люди = useЛюдиДляВыбора(поиск);

  // Поиск показывается, только когда список упёрся в потолок. У заказчика на объекте десяток
  // человек, и поле поиска над списком из шести фамилий — лишний вопрос без ответа.
  const списокПолон = (люди.data?.items.length ?? 0) >= 50;

  return (
    <div className='flex flex-col gap-2'>
      {(списокПолон || поиск !== '') && (
        <TextField
          id={`${id}-search`}
          label='Найти человека'
          value={поиск}
          onChange={setПоиск}
          placeholder='Фамилия'
        />
      )}
      <SelectField
        id={id}
        label='Старший объекта'
        value={значение ?? NO_VALUE}
        onChange={(выбрано) => наВыбор(выбрано === NO_VALUE ? null : выбрано)}
        options={(люди.data?.items ?? []).map((человек) => ({
          value: человек.id,
          label: человек.display_name,
        }))}
        noneLabel='старший не назначен'
        placeholder='Выберите человека'
        pending={люди.isPending}
        failed={люди.isError}
        failedError={люди.error as ApiError | null}
        emptyNote='Людей в реестре нет. Заведите сотрудника в разделе «Люди».'
        hint='Он видит данные этого объекта и получает уведомления по нему: просьбы о деньгах, решения по заявкам, просроченный обход.'
      />
    </div>
  );
}
